import React, { ReactNode } from 'react';
import {
  Checkbox,
  CheckboxProps,
  Row,
  Col,
  LazyImage,
  styled,
  Shape,
  ThemeProps,
} from '@teko/ds-desktop';
import { useTenantConfig } from 'hooks';
import { CloseOutlined } from '@teko/ds-icon';
import PromotionComboEn from 'assets/promotion_combo_en.svg';
import PromotionComboVi from 'assets/promotion_combo_vi.svg';

interface CartComboLineHeaderProps
  extends Pick<CheckboxProps, 'checked' | 'onChange'> {
  children?: ReactNode;
  headerTitle?: ReactNode;
  headerButton?: ReactNode;
  showCheck?: boolean;
  onRemoveCombo: () => void;
}

const StyledCol = styled(Col)`
  display: flex !important;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const StyledRow = styled(Row)(
  ({ theme }: ThemeProps) => `
 border-radius: ${theme?.borderRadius.m} ${theme?.borderRadius.m} 0 0;
`,
);

const CartComboHeader = (props: CartComboLineHeaderProps) => {
  const {
    children,
    headerTitle,
    headerButton,
    checked,
    onChange,
    showCheck = false,
    onRemoveCombo,
    ...tracking
  } = props;

  const { currentLanguage } = useTenantConfig();

  return (
    <Shape
      border="1.5px solid primary200"
      borderRadius="m"
      margin="s16"
      {...tracking}
    >
      <StyledRow
        justify="space-between"
        align="middle"
        padding={['s4', 's16']}
        borderBottom="1px"
        backgroundColor="primary50"
      >
        {showCheck && (
          <Col flex="4%">
            <Row justify="start" align="middle">
              <Checkbox checked={checked} onChange={onChange} />
            </Row>
          </Col>
        )}
        <Col flex={showCheck ? '96%' : '100%'}>
          <Row justify="space-between" align="middle">
            <StyledCol span={9}>
              {currentLanguage === 'vi' ? (
                <LazyImage src={PromotionComboVi} height={40} width={120} />
              ) : (
                <LazyImage src={PromotionComboEn} height={40} width={120} />
              )}
              {headerTitle}
            </StyledCol>
            <Col span={2}>
              <Row justify="end">{headerButton}</Row>
            </Col>
            <Col span={1}>
              <Row justify="end">
                <CloseOutlined
                  size={24}
                  color="placeholder"
                  cursor="pointer"
                  onClick={onRemoveCombo}
                />
              </Row>
            </Col>
          </Row>
        </Col>
      </StyledRow>
      {children}
    </Shape>
  );
};

export default CartComboHeader;
